export interface RentalConsultationFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  weddingDate: string;
  venue: string;
  preferredRentalPeriod: string;
  budget: string;
  dressSize: string;
  preferredStyles: string[];
  specialRequests: string;
  howDidYouHear: string;
}

export interface RentalConsultationFormErrors {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export const initialRentalConsultationFormData: RentalConsultationFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  weddingDate: '',
  venue: '',
  preferredRentalPeriod: '',
  budget: '',
  dressSize: '',
  preferredStyles: [],
  specialRequests: '',
  howDidYouHear: '',
};
